import { getMousePos } from '../utility/input';
import { gsap } from 'gsap';
import { select } from '../utility/dom';
class MagneticElement {
    constructor(element) {
        this._sensibility = 80;
        this._hit = (d) => {
            let _x = d.x;
            if (_x < 0) {
                _x *= -1;
            }
            let _y = d.y;
            if (_y < 0) {
                _y *= -1;
            }
            return _x <= this._sensibility && _y <= this._sensibility;
        };
        this._mousemoveFn = (ev) => requestAnimationFrame(() => {
            const mouse = getMousePos(ev);
            const scrollInset = _getScrollInset();
            const coords = {
                x: this._boundingRect.left + scrollInset.x,
                y: this._boundingRect.top + scrollInset.y,
            };
            const distance = {
                x: mouse.x - coords.x,
                y: mouse.y - coords.y,
            };
            if (this._hit(distance)) {
                gsap.to(this._element, {
                    x: distance.x - (this._boundingRect.width * .5),
                    y: distance.y - (this._boundingRect.height * .5),
                    scale: 1.25,
                    duration: .375,
                    overwrite: true,
                });
            }
            else {
                gsap.to(this._element, {
                    x: 0,
                    y: 0,
                    scale: 1,
                    duration: .25,
                    overwrite: true,
                });
            }
        });
        if (!element) {
            throw new Error('MagneticElement: element not defined');
        }
        if (!(element instanceof HTMLElement)) {
            const el = select(element).first;
            if (!el) {
                throw new Error('MagneticElement: element not found in DOM');
            }
            this._element = el;
        }
        else {
            this._element = element;
        }
        this._boundingRect = this._element.getBoundingClientRect();
        window.addEventListener('mousemove', this._mousemoveFn);
    }
}
const _getScrollInset = () => ({
    x: document.body.scrollLeft + document.documentElement.scrollLeft,
    y: document.body.scrollTop + document.documentElement.scrollTop,
});
;
export default MagneticElement;
